import React, { useLayoutEffect } from 'react';
import RolesList from '../../Components/Roles/RolesListing/RolesList';
import { useSidebar } from '../../Context/SidebarContext/SidebarContext';

const Settings = () => {
  const { setActiveTab } = useSidebar();

  useLayoutEffect(() => {
    setActiveTab("Settings");
  }, []);

  return <RolesList />;
};

export default Settings;
